// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createAdminAccounting = (client) => ({
    /**
     * `POST /admin/accounting/configs`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminCreateAccountingConfig
     * @source packages/medusa-plugin-accounting-zohobooks-v2/src/api/admin/accounting/configs/route.ts
     */
    createConfig: (body, query, headers) => client.fetch("/admin/accounting/configs", { method: "POST", body, query, headers }),
    /**
     * `DELETE /admin/accounting/configs/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminDeleteAccountingConfig
     * @source packages/medusa-plugin-accounting-zohobooks-v2/src/api/admin/accounting/configs/[id]/route.ts
     */
    deleteConfig: (id, body, query, headers) => client.fetch(buildPath("/admin/accounting/configs/:id", [id]), { method: "DELETE", body, query, headers }),
    /**
     * `GET /admin/accounting/configs`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminListAccountingConfigs
     * @source packages/medusa-plugin-accounting-zohobooks-v2/src/api/admin/accounting/configs/route.ts
     */
    listConfigs: (query, headers) => client.fetch("/admin/accounting/configs", { method: "GET", query, headers }),
    /**
     * `GET /admin/accounting/failed-syncs`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminListFailedSyncs
     * @source packages/medusa-plugin-accounting-zohobooks-v2/src/api/admin/accounting/failed-syncs/route.ts
     */
    listFailedSyncs: (query, headers) => client.fetch("/admin/accounting/failed-syncs", { method: "GET", query, headers }),
    /**
     * `GET /admin/accounting/syncs`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminListSyncs
     * @source packages/medusa-plugin-accounting-zohobooks-v2/src/api/admin/accounting/syncs/route.ts
     */
    listSyncs: (query, headers) => client.fetch("/admin/accounting/syncs", { method: "GET", query, headers }),
    /**
     * `POST /admin/accounting/sync/refund`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminSyncRefund
     * @source packages/medusa-plugin-accounting-zohobooks-v2/src/api/admin/accounting/sync/refund/route.ts
     */
    refundSync: (body, query, headers) => client.fetch("/admin/accounting/sync/refund", { method: "POST", body, query, headers }),
    /**
     * `PUT /admin/accounting/configs/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminUpdateAccountingConfig
     * @source packages/medusa-plugin-accounting-zohobooks-v2/src/api/admin/accounting/configs/[id]/route.ts
     */
    updateConfig: (id, body, query, headers) => client.fetch(buildPath("/admin/accounting/configs/:id", [id]), { method: "PUT", body, query, headers }),
    /**
     * `POST /admin/accounting/sync/customer`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminSyncCustomer
     * @source packages/medusa-plugin-accounting-zohobooks-v2/src/api/admin/accounting/sync/customer/route.ts
     */
    updateSyncCustomer: (body, query, headers) => client.fetch("/admin/accounting/sync/customer", { method: "POST", body, query, headers }),
    /**
     * `POST /admin/accounting/sync/order`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminSyncOrder
     * @source packages/medusa-plugin-accounting-zohobooks-v2/src/api/admin/accounting/sync/order/route.ts
     */
    updateSyncOrder: (body, query, headers) => client.fetch("/admin/accounting/sync/order", { method: "POST", body, query, headers }),
    /**
     * `POST /admin/accounting/sync/product`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminSyncProduct
     * @source packages/medusa-plugin-accounting-zohobooks-v2/src/api/admin/accounting/sync/product/route.ts
     */
    updateSyncProduct: (body, query, headers) => client.fetch("/admin/accounting/sync/product", { method: "POST", body, query, headers }),
});
//# sourceMappingURL=accounting.js.map